export * from './isIFramedManagement'
